import styleInject from '../../node_modules/style-inject/dist/153f6fceb51bb0547b1c47281772019ca2a83d6f1f66a0d8c0fb968a56fe84d7.cfe-internal.js';

var css_248z = "._1xuoj{color:#0b6ed0;cursor:pointer;text-decoration:none;border-bottom:1px solid;border-radius:1px}._1xuoj:active:focus,._1xuoj:focus{outline:none}._1xuoj:visited{color:#0854a1}._1xuoj:hover{color:#085caf}._1xuoj:active{color:#0854a1}body.keyboard-user ._1xuoj:active:focus,body.keyboard-user ._1xuoj:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #0a3f88}";
var styles = {"link":"_1xuoj"};
styleInject(css_248z);

export { styles as default };
